import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IPublication } from '@opengov/stories-shared/types';

import { deactivateSharedOnlinePublication } from '../../../../routes/hasura';
import { useUpdatePublicationUpdatedAt } from '../../PublicationView/hooks/usePublicationMutations';
import { publicationViewQueryKeys } from '../../PublicationView/hooks/publicationViewQueryKeys';

import { setupOnlinePublicationQueryKeys } from './setupOnlinePublicationQueryKeys';

export type UseDeactivateOnlinePublicationUrlContext = {
  entitySubdomain: string;
  entityId: number;
};

export type DeactivateOnlinePublicationUrlVariables = {
  publication: IPublication;
  userId: number;
};

export function useDeactivateOnlinePublicationUrl(context: UseDeactivateOnlinePublicationUrlContext) {
  const queryClient = useQueryClient();
  const updatePublicationUpdatedAt = useUpdatePublicationUpdatedAt();

  return useMutation<string, Error, DeactivateOnlinePublicationUrlVariables>({
    mutationKey: [...setupOnlinePublicationQueryKeys.all, 'deactivateOnlinePublicationUrl', context],
    mutationFn: async ({ publication, userId }) => {
      const publicationId = publication.id;
      const publishedId = publication.publicUrl?.split('/').pop() ?? '';
      const url = await deactivateSharedOnlinePublication(
        publicationId,
        context.entitySubdomain,
        context.entityId,
        publishedId
      );

      // Update timestamp + invalidate query (replaces effect calls)
      if (url) {
        await updatePublicationUpdatedAt.mutateAsync({ publicationId, userId });
        await queryClient.invalidateQueries({
          queryKey: publicationViewQueryKeys.publication({ publicationId })
        });
      }

      return url;
    }
  });
}
